/* Disabled because we are using redux toolkit */
/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';

import { SessionState } from './types';
import { initializeSession, login, logout, storeUser, signUp, updateUserProfileAction } from './actions';

const initialState: SessionState = {
    user: null,
    role: null,
    isLoading: { user: false, init: true },
};

const setInitFinished = (state: SessionState) => {
    state.isLoading.init = false;
};

const setUserLoading = (state: SessionState) => {
    state.isLoading.user = true;
};

const clearUserData = (state: SessionState) => {
    state.user = null;
    state.role = null;
    state.isLoading.user = false;
};

const setUserLoadingFinished = (state: SessionState) => {
    state.isLoading.user = false;
};

export const sessionReducer = createReducer(initialState, (builder) => {
    builder.addCase(storeUser, (state, action) => {
        state.user = action.payload;
    });

    builder.addCase(initializeSession.pending, (state) => {
        state.isLoading.init = true;
    });
    builder.addCase(initializeSession.fulfilled, (state, action) => {
        if (action.payload) {
            state.user = action.payload.userInfo;
            state.role = action.payload.role;
        }
        state.isLoading.init = false;
    });
    builder.addCase(initializeSession.rejected, setInitFinished);

    builder.addCase(login.pending, setUserLoading);
    builder.addCase(login.fulfilled, (state, action) => {
        state.user = action.payload.userInfo;
        state.role = action.payload.role;
        state.isLoading.user = false;
    });
    builder.addCase(login.rejected, clearUserData);

    builder.addCase(signUp.pending, setUserLoading);
    builder.addCase(signUp.fulfilled, (state) => {
        state.isLoading.user = false;
    });
    builder.addCase(signUp.rejected, clearUserData);

    builder.addCase(logout.pending, setUserLoading);
    builder.addCase(logout.fulfilled, clearUserData);
    builder.addCase(logout.rejected, setUserLoadingFinished);

    builder.addCase(updateUserProfileAction.pending, setUserLoading);
    builder.addCase(updateUserProfileAction.fulfilled, (state, action) => {
        state.isLoading.user = false;
        if (state.user && action.payload) {
            state.user = action.payload;
        }
    });
    builder.addCase(updateUserProfileAction.rejected, setUserLoadingFinished);

    // builder.addCase(updateUserPassword.pending, setUserLoading);
    // builder.addCase(updateUserPassword.fulfilled, setUserLoadingFinished);
    // builder.addCase(updateUserPassword.rejected, setUserLoadingFinished);
});
